var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircleRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 7.99998C14.4 11.5346 11.5346 14.4 7.99998 14.4C4.46535 14.4 1.59998 11.5346 1.59998 7.99998C1.59998 4.46535 4.46535 1.59998 7.99998 1.59998C11.5346 1.59998 14.4 4.46535 14.4 7.99998ZM5.43429 5.43431C5.74671 5.12189 6.25324 5.12189 6.56566 5.43431L7.99996 6.86862L9.43429 5.43429C9.74671 5.12187 10.2532 5.12187 10.5657 5.43429C10.8781 5.74671 10.8781 6.25324 10.5657 6.56566L9.13133 7.99999L10.5657 9.43431C10.8781 9.74673 10.8781 10.2533 10.5657 10.5657C10.2532 10.8781 9.74671 10.8781 9.43429 10.5657L7.99996 9.13136L6.56566 10.5657C6.25324 10.8781 5.74671 10.8781 5.43429 10.5657C5.12187 10.2532 5.12187 9.74671 5.43429 9.43429L6.86859 7.99999L5.43429 6.56568C5.12187 6.25327 5.12187 5.74673 5.43429 5.43431Z",
    fill: "#FF5865"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleRed);
export default __webpack_public_path__ + "static/media/close-circle-red.de449d7e2be73cb10ca3d41c2858947e.svg";
export { ForwardRef as ReactComponent };